// extracted by mini-css-extract-plugin
module.exports = {"b":"_3SxSa","toggle":"_24_Dt","check":"_2hxKA","track":"_2K4Na","blueToggle":"_32PV7","switch":"_194zE","switchBlue":"_3aznu","switchBlueInactive":"KzCxL"};